module.exports = __webpack_public_path__ + "img/Material2.b0a5485d.gif";